<template>
  <!-- 
        Компонент зі списком компаній, в якому ви можете - 
        - переглянути список компаній (активні та видалені) та скористатить пошуком (назві, id компанії)
        - обрати компанію 
        - змінити ліміт компаній
        - увімкнути нову версії
        - скопіювати дані з старої версію в нову
        - та інше :)
    -->

  <div>
    <h1 style="display: flex">
      <!-- Заголовок компоненту "Всі компанії" -->
      <b>{{ $t("AllCompany") }}</b>
      <button
        type="button"
        v-if="perms[20211] || perms[2000]"
        @click="showDialog = true"
        class="btn btn-outline-secondary waves-effect waves-light"
        style="margin-left: 10px"
      >
        {{ $t("ChangeLimitCompanies") }}
      </button>

      <!-- Кнопка для виклику додаткових опцій у випадаючому списку -->
      <div
        class="dropdown"
        v-if="perms[2021] || perms[20212] || perms[2027] || perms[2000]"
        style="margin-left: 7px; align-items: center; display: flex"
      >
        <button
          class="btn btn-ghost-secondary btn-icon btn-sm fs-16"
          type="button"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="bx bx-dots-vertical-rounded align-bottom"></i>
        </button>

        <!-- Випадаюче меню з додатковими опціями -->
        <div class="dropdown-menu dropdown-menu-end dropdownmenu-info">
          <div class="dropdown-header noti-title border-bottom mb-2">
            <h5 class="font-size-13 text-muted text-truncate mn-0 fw-semibold">
              {{ $t("chooseATask") }}
            </h5>
          </div>

          <!-- Увімкнути нову версію -->
          <button
            v-if="perms[2021] || perms[2000]"
            class="dropdown-item"
            @click="modalCreated.show = true"
          >
            {{ $t("EnablenewVersion") }}
          </button>

          <!-- Увімкнути нову версію з копіюванням -->
          <button
            v-if="perms[2021] || perms[2000]"
            class="dropdown-item"
            @click="openCreatedSky()"
          >
            {{ $t("EnablenewVersion") }} ({{ $t("WithCopying") }})
          </button>

          <!-- Копіювати дані зі старої версії до нової -->
          <button
            v-if="perms[20212] || perms[2000]"
            class="dropdown-item"
            @click="openCopyInSky()"
          >
            {{ $t("trans_data_from_old_company") }}
          </button>

          <div v-if="perms[2027] || perms[2000]" class="dropdown-divider"></div>

          <!-- Скинути пароль -->
          <button
            v-if="perms[2027] || perms[2000]"
            class="dropdown-item"
            @click="ResetPass()"
          >
            {{ $t("resetPassword") }}
          </button>
        </div>
      </div>
    </h1>

    <span>{{ $t("enterCompany") }}</span>

    <!-- Поле для введення тексту пошуку -->
    <input type="text" v-model="search" class="form-control" />

    <b-row class="mt-3">
      <template v-for="item in filteredCompanies" :key="item">
        <!-- Карточка для кожної компанії з можливістю кліку -->
        <b-col
          v-if="item.companyId != null"
          lg="3"
          @contextmenu.prevent="showContextMenu($event, item)"
          @click="
            item.companyDescription != 'root'
              ? openComp(item.companyId)
              : this.$toast.error(this.$t('error'))
          "
        >
          <!-- Мінімалістичний дизайн картки -->
          <div
            class="company-card"
            :class="{
              'company-card--searched': companyFromSearch == item.companyId,
              'company-card--blocked': item.blocked,
              'company-card--old': isOldVersion(item)
            }"
          >
            <!-- Заголовок з назвою -->
            <div class="company-card__header">
              <h5 class="company-card__title">{{ item.companyName || 'Без назви' }}</h5>
            </div>

            <!-- Бейджі -->
            <div class="company-card__badges mb-2">
              <!-- Бейдж сервера -->
              <span
                v-if="item.more && item.more.companyServer"
                class="badge"
                :class="getServerBadgeClass(item.more)"
              >
                {{ getServerDisplayName(item.more) }}
              </span>
              <!-- Бейдж метод обліку -->
              <!-- <span
                v-if="showCostMethod(item)"
                class="badge bg-soft-warning text-warning"
              >
                {{ getCostMethod(item) }}
              </span> -->
              <!-- Бейдж черги -->
              <span
                v-if="item.more && item.more.useQueue !== undefined && showQueueBadge(item)"
                class="badge"
                :class="item.more.useQueue ? 'bg-soft-success text-success' : 'bg-soft-secondary text-secondary'"
              >
                {{ item.more.useQueue ? $t('Queues') || 'Черги' : $t('NoQueues') || 'Без черг' }}
              </span>
              <!-- Бейдж заблоковано -->
              <span v-if="item.blocked" class="badge bg-danger">
                {{ $t('Blocked') || 'Заблоковано' }}
              </span>
            </div>

            <!-- Основна інформація -->
            <div class="company-card__body">
              <!-- ID компанії -->
              <p class="company-card__id">
                <i class="bx bx-hash"></i>
                {{ item.companyId || '-' }}
              </p>

              <!-- Опис -->
              <p v-if="item.companyDescription && item.companyDescription !== 'root'" class="company-card__desc">
                {{ item.companyDescription }}
              </p>
            </div>

            <!-- Футер з метаінформацією -->
            <div class="company-card__footer">
              <!-- Тип права -->
              <span class="company-card__role">
                <i class="bx bx-user"></i>
                {{ mutateUser(item.personAdmin) }}
              </span>

              <!-- Дата створення -->
              <span v-if="item.more && item.more.dateOfCreate" class="company-card__date">
                <i class="bx bx-calendar"></i>
                {{ item.more.dateOfCreate }}
              </span>
            </div>

            <!-- Індикатор пошуку -->
            <div v-if="companyFromSearch == item.companyId" class="company-card__search-indicator">
              <i class="bx bx-search"></i>
              {{ $t("youFoundComp") }}
            </div>
          </div>
        </b-col>
      </template>

      <!-- Карточка для видалених компаній -->
      <b-col
        lg="3"
        v-for="item in filteredItemsDel"
        :key="item"
        @contextmenu.prevent="showContextMenu($event, item)"
        @click="openComp(item.companyId)"
      >
        <div
          class="company-card company-card--deleted"
          :class="{ 'company-card--searched': companyFromSearch == item.companyId }"
        >
          <!-- Заголовок -->
          <div class="company-card__header">
            <h5 class="company-card__title">{{ item.companyName || 'Без назви' }}</h5>
          </div>

          <!-- Бейджі -->
          <div class="company-card__badges mb-2">
            <span class="badge bg-danger">{{ $t('deleted') || 'Видалено' }}</span>
          </div>

          <!-- Основна інформація -->
          <div class="company-card__body">
            <p class="company-card__id">
              <i class="bx bx-hash"></i>
              {{ item.companyId || '-' }}
            </p>
            <p v-if="item.companyDescription" class="company-card__desc">
              {{ item.companyDescription }}
            </p>
          </div>

          <!-- Футер -->
          <div class="company-card__footer">
            <span class="company-card__role">
              <i class="bx bx-user"></i>
              {{ mutateUser(item.personAdmin) }}
            </span>
            <span v-if="item.more && item.more.dateOfCreate" class="company-card__date">
              <i class="bx bx-calendar"></i>
              {{ item.more.dateOfCreate }}
            </span>
          </div>

          <!-- Індикатор пошуку -->
          <div v-if="companyFromSearch == item.companyId" class="company-card__search-indicator">
            <i class="bx bx-search"></i>
            {{ $t("youFoundComp") }}
          </div>
        </div>
      </b-col>
    </b-row>
  </div>

  <!-- Модальне вікно для редагування ліміту компаній -->
  <dialogBox v-if="showDialog" @close="showDialog = false">
    <template v-slot:title>{{ $t("ChangeLimitCompanies") }}</template>
    <template v-slot:body>
      <div class="mt-1 pb-3 text-center">
        <h3>
          <b>{{ $t("SpecifyLimitCompanies") }}</b>
        </h3>

        <!-- Поле для введення нового ліміту компаній -->
        <input
          type="number"
          class="form-control w-50 m-auto"
          :placeholder="$t('enteraNumber')"
          v-model="form.newNumberOfCompanies"
          oninput="this.value = this.value.replace(/\./g, '')"
        />
      </div>
    </template>
    <template v-slot:footer-bottom>
      <div class="hstack gap-2 mt-3 justify-content-center remove">
        <!-- Кнопка для закриття модального вікна -->
        <button class="btn btn-danger" @click="showDialog = false">
          {{ $t("cancel") }}
        </button>

        <!-- Кнопка для редагування ліміту компаній -->
        <button class="btn btn-success" @click="editMaxNumber()">
          {{ $t("Edit") }}
        </button>
      </div>
    </template>
  </dialogBox>

  <!-- Модальне вікно створення нової компанії -->
  <dialogBox
    v-if="modalCreated.show"
    @close="
      modalCreated.show = false;
      modalCreated.copy = false;
    "
  >
    <template v-slot:title>{{ $t("EnablenewVersion") }}</template>
    <template v-slot:body>
      <template v-if="modalCreated.copy == true">
        <div class="mt-1 pb-3">
          <!-- Обрати компанію -->
          <div class="mb-3">
            <h4 class="fs-15">{{ $t("enterCompany") }}</h4>
            <Multiselect
              v-model="companyId"
              :close-on-select="true"
              :searchable="true"
              :object="true"
              :create-option="false"
              :options="listActiveCompany"
              :placeholder="$t('enterCompany')"
            />
          </div>

          <div class="mb-1">
            <!-- 
                            Селектор на вибір точки (не масив)
                        -->
            <h4 class="fs-15">{{ $t("EnterTradePoint") }}</h4>
            <Multiselect
              v-model="selectedOneTT"
              :close-on-select="true"
              :searchable="true"
              :object="true"
              :options="listTT"
            />

            <!-- 
                            Кнопка для отримання торгових точок по обраній компанії
                        -->
            <button
              class="btn btn-outline-success mt-2 mb-2"
              type="button"
              @click="getTT"
            >
              {{ $t("getRequestTT") }}
            </button>
          </div>
        </div>
      </template>
      <template v-else>
        <h3 class="text-center">
          <b>{{ $t("ConfirmCreationNewVersion") }}</b>
        </h3>
        <div class="alert alert-info">
          <p class="mb-0">
            <span class="fw-semibold">{{ $t("confirmation") }} :</span>
            {{ $t("SpecifyTestWord") }} "new"
          </p>
        </div>
        <input
          class="form-control"
          v-model="userInput"
          @input="checkInput"
          :placeholder="$t('SpecifyTestWord')"
        />
      </template>
    </template>
    <template v-slot:footer-bottom>
      <div class="hstack gap-2 mt-3 justify-content-center remove">
        <!-- Кнопка для закриття модального вікна -->
        <button
          class="btn btn-danger"
          @click="
            modalCreated.show = false;
            modalCreated.copy = false;
          "
        >
          {{ $t("cancel") }}
        </button>

        <!-- Кнопка для редагування ліміту компаній -->
        <button
          v-if="status || modalCreated.copy == true"
          class="btn btn-success"
          @click="
            modalCreated.copy == true
              ? createAndTransferDataSkyNew()
              : createSkyNewForClient()
          "
        >
          {{ $t("perform") }}
        </button>
      </div>
    </template>
  </dialogBox>

  <!-- Модальне вікно копіювання між компаніями -->
  <dialogBox v-if="modalCopy.show" @close="modalCopy.show = false">
    <template v-slot:title>{{ $t("EnablenewVersion") }}</template>
    <template v-slot:body>
      <div class="mt-1 pb-3">
        <!-- Виберіть компанію з якою відбуватиметься копіювання -->
        <div class="mb-3">
          <h4 class="fs-15">{{ $t("enterCompanyFirst") }}</h4>
          <Multiselect
            v-model="companyId"
            :close-on-select="true"
            :searchable="true"
            :object="true"
            :create-option="false"
            :options="listActiveCompany"
            :placeholder="$t('enterCompany')"
          />
        </div>

        <!-- Виберіть компанію, на яку відбуватиметься копіювання -->
        <div class="mb-3">
          <h4 class="fs-15">{{ $t("enterCompanySecond") }}</h4>
          <Multiselect
            v-model="companySecondId"
            :close-on-select="true"
            :searchable="true"
            :object="true"
            :create-option="false"
            :options="listActiveNewCompany"
            :placeholder="$t('enterCompany')"
          />
        </div>

        <div class="mb-1">
          <!-- 
                        Селектор на вибір точки (не масив)
                    -->
          <h4 class="fs-15">{{ $t("EnterTradePoint") }}</h4>
          <Multiselect
            v-model="selectedOneTT"
            :close-on-select="true"
            :searchable="true"
            :object="true"
            :options="listTT"
          />

          <!-- 
                        Кнопка для отримання торгових точок по обраній компанії
                    -->
          <button
            class="btn btn-outline-success mt-2 mb-2"
            type="button"
            @click="getTT"
          >
            {{ $t("getRequestTT") }}
          </button>
        </div>
      </div>
    </template>
    <template v-slot:footer-bottom>
      <div class="hstack gap-2 mt-3 justify-content-center remove">
        <!-- Кнопка для закриття модального вікна -->
        <button
          class="btn btn-danger"
          @click="
            modalCreated.show = false;
            modalCreated.copy = false;
          "
        >
          {{ $t("cancel") }}
        </button>

        <!-- Кнопка для редагування ліміту компаній -->
        <button class="btn btn-success" @click="transDataFromOldCompany()">
          {{ $t("perform") }}
        </button>
      </div>
    </template>
  </dialogBox>

  <!-- Модальне вікно з детальною інформацією про компанію -->
  <dialogBox v-if="objInfoComp.show" @close="objInfoComp.show = false">
    <template v-slot:title>{{ $t("AboutTheCompany") }}</template>
    <template v-slot:body>
      <div class="mb-3">
        <h4 class="fs-15">{{ $t("CompanyName") }}</h4>
        <input
          type="text"
          class="form-control m-auto"
          :value="objInfoComp.data.companyName"
          disabled
        />
      </div>
      <div class="mb-3">
        <h4 class="fs-15">{{ $t("desc") }}</h4>
        <input
          type="text"
          class="form-control m-auto"
          :value="
            objInfoComp.data.companyDescription
              ? objInfoComp.data.companyDescription
              : '-'
          "
          disabled
        />
      </div>
      <div class="mb-3">
        <h4 class="fs-15">ID {{ $t("Companies") }}</h4>
        <input
          type="text"
          class="form-control m-auto"
          :value="objInfoComp.data.companyId ? objInfoComp.data.companyId : '-'"
          disabled
        />
      </div>
      <div class="mb-3">
        <h4 class="fs-15">{{ $t("DateTimeCompanyCreation") }}</h4>
        <input
          type="text"
          class="form-control m-auto"
          :value="
            objInfoComp.data.more.dateOfCreate
              ? objInfoComp.data.more.dateOfCreate
              : '-'
          "
          disabled
        />
      </div>
      <div class="mb-3" v-if="objInfoComp.data.delete.dateOfDelete">
        <h4 class="fs-15">{{ $t("DateTimeCompanyDelete") }}</h4>
        <input
          type="text"
          class="form-control m-auto"
          :value="
            objInfoComp.data.delete.dateOfDelete
              ? objInfoComp.data.delete.dateOfDelete
              : '-'
          "
          disabled
        />
      </div>
      <hr />
      <div class="mb-3">
        <h4 class="fs-15">{{ $t("Server") }}</h4>
        <input
          type="text"
          class="form-control m-auto"
          :value="
            objInfoComp.data.more.companyServer
              ? objInfoComp.data.more.companyServer
              : '-'
          "
          disabled
        />
      </div>
    </template>
    <template v-slot:footer-bottom>
      <div class="hstack gap-2 mt-3 justify-content-center remove">
        <!-- Кнопка для закриття модального вікна -->
        <button class="btn btn-info" @click="objInfoComp.show = false">
          {{ $t("close") }}
        </button>
      </div>
    </template>
  </dialogBox>

  <!-- Контекстне меню -->
  <my-context-menu
    ref="contextMenu"
    :btn="btnContextMenu"
    @select="switchCntMenu"
  />
</template>

<script>
import dialogBox from "@/components/modal/dialog"; // компонент модального вікна
import Multiselect from "@vueform/multiselect"; // компонент мультіселектора
import "@vueform/multiselect/themes/default.css"; // стилі до компоненту мультіселектора
import MyContextMenu from "@/components/contextMenu/index.vue"; // компонент контекст-меню
import {
  mutateUserCompanies,
  mutateCompServer,
} from "@/usabilityScripts/globalMutate.js";
import { SuperAdmin, Clients } from "@/API"; // клас API, який викорстовується в файлі
import { storeS } from "@/store"; // Глобальне сховище даних
import { copy } from "@/usabilityScripts/copy.js";

let apiClients = new Clients();
let apiServe = new SuperAdmin();

export default {
  props: ["companies", "deletedcompanies", "accountId", "companyFromSearch"],
  components: {
    dialogBox,
    Multiselect,
    MyContextMenu,
  },
  data() {
    return {
      search: "", // поле пошуку
      showDialog: false, // стан відображення діалогового вікна
      modalCreated: {
        // стан відображення діалогового вікна створення компанії та прапорець на копіювання
        show: false,
        copy: false,
      },
      modalCopy: {
        // стан відображення діалогового вікна копіювання між компаніями
        show: false,
      },
      companyId: "", // обрана компанія (стара адмінка)
      companySecondId: "", // обрана друга компанія (нова адмінка)
      listTT: [], // список точок
      selectedOneTT: "", // обрані точки/точка
      listActiveCompany: [], // список активованих компаній (стара версія)
      listActiveNewCompany: [], // список активованих компаній (нова версія)
      form: {
        // параметри форми
        newNumberOfCompanies: "", // новий ліміт компаній, має бути ціле число
      },
      userInput: "", // Поле вводу перевірочного слова
      status: false, // активація кнопки після капчі
      objInfoComp: {
        show: false,
        data: {},
      },
      btnContextMenu: [
        // Параметри для контекстного меню
        {
          title: this.$t("Open"),
          icon: "bx bxs-door-open",
          color: "info",
          value: "open",
          status: true,
          perms: null,
        },
        {
          title: this.$t("CopyName"),
          icon: "bx bx-copy-alt",
          color: "info",
          value: "CopyName",
          status: true,
          perms: null,
        },
        {
          title: this.$t("copyIdCompany"),
          icon: "bx bxs-copy-alt",
          color: "info",
          value: "copyIdCompany",
          status: true,
          perms: null,
        },
        {
          title: this.$t("MoreInformation"),
          icon: "bx bxs-info-circle",
          color: "info",
          value: "MoreInformation",
          status: true,
          perms: null,
        },
        {
          title: this.$t("Checks"),
          icon: "bx bx-list-ul",
          color: "info",
          value: "openChecks",
          status: true,
          perms: null,
        },
      ],
      tabIndex: "",
      uniqueCompanies: [],
    };
  },
  created() {
    this.removeDuplicate();
  },
  methods: {
    removeDuplicate() {
      // Метод видалення дублікатів компанії

      let companies = this.companies;

      // Використовуємо об'єкт для зберігання унікальних значень за обраними властивостями
      let uniqueMap = {};

      // Проходимо по кожній компанії і додаємо її до об'єкту uniqueMap, якщо вона відповідає критеріям
      companies.forEach((company) => {
        const { companyId, personAdmin } = company;
        const key = `${companyId}_${personAdmin}`;

        if (!uniqueMap[key]) {
          uniqueMap[key] = company;
        }
      });

      // Перетворюємо об'єкт у масив унікальних компаній
      let uniqueCompanies = Object.values(uniqueMap);

      this.uniqueCompanies = uniqueCompanies;
    },
    openComp(accID, tab) {
      // Метод для відкриття компанії за ідентифікатором
      this.$emit("opencompany", accID, tab);
    },
    editMaxNumber() {
      // Метод для редагування ліміту компаній
      apiServe
        .editMaxNumberOfCompanies(this.accountId, this.form)
        .then((result) => {
          if (result.status == "done") {
            this.$toast.success(this.$t("newLimitBeenApplied"));
            this.showDialog = false;
            this.form.newNumberOfCompanies = "";
          } else {
            this.$toast.error(this.$t("err"));
          }
        });
    },
    openCreatedSky() {
      this.listActiveCompany = [];

      // Формуємо список компаній в потрібно вигляді
      for (var item in this.companies) {
        if (this.companies[item].more.companyServer == "s-1") {
          this.listActiveCompany.push({
            label: `${this.companies[item].companyName}`,
            value: `${this.companies[item].companyId}`,
          });
        }
      }

      // Якщо тільки одна компанія, то образу її застосуємо у поле вибору компанії
      if (this.listActiveCompany.length == 1) {
        this.companyId = this.listActiveCompany[0];
      }

      this.modalCreated.copy = true;
      this.modalCreated.show = true;
    },
    openCopyInSky() {
      this.listActiveCompany = [];
      this.listActiveNewCompany = [];

      // Формуємо список компаній в потрібно вигляді (старі версії)
      for (var item in this.companies) {
        if (this.companies[item].more.companyServer == "s-1") {
          this.listActiveCompany.push({
            label: `${this.companies[item].companyName}`,
            value: `${this.companies[item].companyId}`,
          });
        }
      }

      // Якщо тільки одна компанія, то образу її застосуємо у поле вибору компанії
      if (this.listActiveCompany.length == 1) {
        this.companyId = this.listActiveCompany[0];
      }

      // Формуємо список компаній в потрібно вигляді (нові версії)
      for (var item in this.companies) {
        if (this.companies[item].more.companyServer != "s-1") {
          this.listActiveNewCompany.push({
            label: `${this.companies[item].companyName}`,
            value: `${this.companies[item].companyId}`,
          });
        }
      }

      // Якщо тільки одна компанія, то образу її застосуємо у поле вибору компанії
      if (this.listActiveNewCompany.length == 1) {
        this.companySecondId = this.listActiveNewCompany[0];
      }

      this.modalCopy.show = true;
    },
    getTT() {
      // Отримати торгові точки по компанії
      this.listTT = [];

      apiServe.getCompClient(this.companyId.value).then((result) => {
        if (result.status == "done") {
          if (result.data.companyDataObj.tradepoints.length > 0) {
            var tradepoints = result.data.companyDataObj.tradepoints;
            console.log("tradepoints", tradepoints);
            for (var item in tradepoints) {
              this.listTT.push({
                label: tradepoints[item].tradepointName,
                value: tradepoints[item].tradepointId,
              });
            }
            this.$toast.success(this.$t("outletsReceived"));
          } else {
            this.$toast.error(this.$t("ThereNoTTFound"));
          }
        } else {
          // Помилка
          this.$toast.error(this.$t("ThereNoTTFound"));

          // Відправляємо помилку в телеграм
          var errorText = "Помилка відкриття компанії клієнта";
          var statusRequest = result.status;
          var api = "getCompClient";
          var fileRequest = "src/views/tasks/createtask.vue";
          var params = this.mainCompany.value;
          var response = result;

          // Викликаємо функцію для відправки повідомлення в телеграм
          sendTelegramMessage(
            errorText,
            statusRequest,
            api,
            fileRequest,
            params,
            response
          )
            .then((response) =>
              console.log("Telegram API response:", response.data)
            )
            .catch((error) => console.error("Telegram API error:", error));
        }
      });
    },
    checkInput() {
      // Перевіряємо вказане слово
      if (this.userInput === "new") {
        this.status = true;
      } else {
        this.status = false;
      }
    },
    createSkyNewForClient() {
      // Стоврити нову версію (без копіювання)
      apiServe.createSkyNewForClient(this.accountId).then((result) => {
        if (result.status == "done") {
          this.$toast.success(this.$t("done"));
          this.modalCreated.show = false;
          this.modalCreated.copy = false;
          this.$emit("updateCard");
        } else if (
          result.status == "error" &&
          result.error[0] == "account not found"
        ) {
          this.$toast.error(this.$t("AccountNotFound"));

          var errorText = "Помилка при створені компанії нової-адмінки таски";
          var statusRequest = result.status;
          var api = "createSkyNewForClient";
          var fileRequest =
            "src/views/accounts/allAccounts/viewnew/blocks/companies.vue";
          var params = this.form.accountId;
          var response = result;

          // Викликаємо функцію для відправки повідомлення в телеграм
          sendTelegramMessage(
            errorText,
            statusRequest,
            api,
            fileRequest,
            params,
            response
          )
            .then((response) =>
              console.log("Telegram API response:", response.data)
            )
            .catch((error) => console.error("Telegram API error:", error));
        } else if (
          result.status == "error" &&
          result.error[0] == "enter account id"
        ) {
          this.$toast.error(this.$t("EnterYourAccount"));

          var errorText = "Помилка при створені компанії нової-адмінки таски";
          var statusRequest = result.status;
          var api = "createSkyNewForClient";
          var fileRequest =
            "src/views/accounts/allAccounts/viewnew/blocks/companies.vue";
          var params = this.form.accountId;
          var response = result;

          // Викликаємо функцію для відправки повідомлення в телеграм
          sendTelegramMessage(
            errorText,
            statusRequest,
            api,
            fileRequest,
            params,
            response
          )
            .then((response) =>
              console.log("Telegram API response:", response.data)
            )
            .catch((error) => console.error("Telegram API error:", error));
        } else {
          this.$toast.error(this.$t("error"));

          var errorText = "Помилка при створені компанії нової-адмінки таски";
          var statusRequest = result.status;
          var api = "createSkyNewForClient";
          var fileRequest =
            "src/views/accounts/allAccounts/viewnew/blocks/companies.vue";
          var params = this.form.accountId;
          var response = result;

          // Викликаємо функцію для відправки повідомлення в телеграм
          sendTelegramMessage(
            errorText,
            statusRequest,
            api,
            fileRequest,
            params,
            response
          )
            .then((response) =>
              console.log("Telegram API response:", response.data)
            )
            .catch((error) => console.error("Telegram API error:", error));
        }
      });
    },
    createAndTransferDataSkyNew() {
      // створити нову компанію з новою адмінкою клієнту (з копіюванням даних зі старого скаю)

      var newObj = {
        accountId: this.accountId,
        oldCompanyId: this.companyId.value,
        tradepointId: this.selectedOneTT.value,
      };

      apiServe.createAndTransferDataSkyNew(newObj).then((result) => {
        if (result.status == "done") {
          if (result.data?.transferred == true) {
            this.$toast.success(this.$t("done"));
            this.modalCreated.show = false;
            this.modalCreated.copy = false;
            this.$emit("updateCard");
          } else {
            this.$toast.error(this.$t("CopyingNotOccur"));

            var errorText =
              "Помилка при створені компанії нової-адмінки з копіюванням зі статусом Done";
            var statusRequest = result.status;
            var api = "createAndTransferDataSkyNew";
            var fileRequest =
              "src/views/accounts/allAccounts/viewnew/blocks/companies.vue";
            var params = newObj;
            var response = result;

            // Викликаємо функцію для відправки повідомлення в телеграм
            sendTelegramMessage(
              errorText,
              statusRequest,
              api,
              fileRequest,
              params,
              response
            )
              .then((response) =>
                console.log("Telegram API response:", response.data)
              )
              .catch((error) => console.error("Telegram API error:", error));
          }
        } else if (
          result.status == "error" &&
          result.error[0] == "account not found"
        ) {
          this.$toast.error(this.$t("AccountNotFound"));

          var errorText =
            "Помилка при створені компанії нової-адмінки з копіюванням таски";
          var statusRequest = result.status;
          var api = "createAndTransferDataSkyNew";
          var fileRequest =
            "src/views/accounts/allAccounts/viewnew/blocks/companies.vue";
          var params = newObj;
          var response = result;

          // Викликаємо функцію для відправки повідомлення в телеграм
          sendTelegramMessage(
            errorText,
            statusRequest,
            api,
            fileRequest,
            params,
            response
          )
            .then((response) =>
              console.log("Telegram API response:", response.data)
            )
            .catch((error) => console.error("Telegram API error:", error));
        } else if (
          result.status == "error" &&
          result.error[0] == "enter account id"
        ) {
          this.$toast.error(this.$t("EnterYourAccount"));

          var errorText =
            "Помилка при створені компанії нової-адмінки з копіюванням таски";
          var statusRequest = result.status;
          var api = "createAndTransferDataSkyNew";
          var fileRequest =
            "src/views/accounts/allAccounts/viewnew/blocks/companies.vue";
          var params = newObj;
          var response = result;

          // Викликаємо функцію для відправки повідомлення в телеграм
          sendTelegramMessage(
            errorText,
            statusRequest,
            api,
            fileRequest,
            params,
            response
          )
            .then((response) =>
              console.log("Telegram API response:", response.data)
            )
            .catch((error) => console.error("Telegram API error:", error));
        } else {
          this.$toast.error(this.$t("error"));

          console.log("else 4 >");

          var errorText =
            "Помилка при створені компанії нової-адмінки з копіюванням таски";
          var statusRequest = result.status;
          var api = "createAndTransferDataSkyNew";
          var fileRequest =
            "src/views/accounts/allAccounts/viewnew/blocks/companies.vue";
          var params = newObj;
          var response = result;

          // Викликаємо функцію для відправки повідомлення в телеграм
          sendTelegramMessage(
            errorText,
            statusRequest,
            api,
            fileRequest,
            params,
            response
          )
            .then((response) =>
              console.log("Telegram API response:", response.data)
            )
            .catch((error) => console.error("Telegram API error:", error));
        }
      });
    },
    transDataFromOldCompany() {
      // скопіювати дані з старої адмінки в нову

      var newObj = {
        oldCompanyId: this.companyId.value,
        newCompanyId: this.companySecondId.value,
        tradepointId: this.selectedOneTT.value,
      };

      console.log("newobj", newObj);
      apiServe.transDataFromOldCompany(newObj).then((result) => {
        if (result.status == "done") {
          if (result.data?.transferred == true) {
            this.$toast.success(this.$t("done"));
            this.modalCopy.show = false;
            this.$emit("updateCard");
          } else {
            this.$toast.error(this.$t("CopyingNotOccur"));

            var errorText = "Помилка при копіюванні даних з статусом Done";
            var statusRequest = result.status;
            var api = "transDataFromOldCompany";
            var fileRequest =
              "src/views/accounts/allAccounts/viewnew/blocks/companies.vue";
            var params = newObj;
            var response = result;

            // Викликаємо функцію для відправки повідомлення в телеграм
            sendTelegramMessage(
              errorText,
              statusRequest,
              api,
              fileRequest,
              params,
              response
            )
              .then((response) =>
                console.log("Telegram API response:", response.data)
              )
              .catch((error) => console.error("Telegram API error:", error));
          }
        } else if (
          result.status == "error" &&
          result.error[0] == "account not found"
        ) {
          this.$toast.error(this.$t("AccountNotFound"));

          var errorText = "Помилка при копіюванні даних";
          var statusRequest = result.status;
          var api = "transDataFromOldCompany";
          var fileRequest =
            "src/views/accounts/allAccounts/viewnew/blocks/companies.vue";
          var params = newObj;
          var response = result;

          // Викликаємо функцію для відправки повідомлення в телеграм
          sendTelegramMessage(
            errorText,
            statusRequest,
            api,
            fileRequest,
            params,
            response
          )
            .then((response) =>
              console.log("Telegram API response:", response.data)
            )
            .catch((error) => console.error("Telegram API error:", error));
        } else if (
          result.status == "error" &&
          result.error[0] == "enter account id"
        ) {
          this.$toast.error(this.$t("EnterYourAccount"));

          var errorText = "Помилка при копіюванні даних";
          var statusRequest = result.status;
          var api = "transDataFromOldCompany";
          var fileRequest =
            "src/views/accounts/allAccounts/viewnew/blocks/companies.vue";
          var params = newObj;
          var response = result;

          // Викликаємо функцію для відправки повідомлення в телеграм
          sendTelegramMessage(
            errorText,
            statusRequest,
            api,
            fileRequest,
            params,
            response
          )
            .then((response) =>
              console.log("Telegram API response:", response.data)
            )
            .catch((error) => console.error("Telegram API error:", error));
        } else if (
          result.status == "error" &&
          result.error[0] == "enter data"
        ) {
          this.$toast.error(this.$t("enterData"));

          var errorText = "Помилка при копіюванні даних";
          var statusRequest = result.status;
          var api = "transDataFromOldCompany";
          var fileRequest =
            "src/views/accounts/allAccounts/viewnew/blocks/companies.vue";
          var params = newObj;
          var response = result;

          // Викликаємо функцію для відправки повідомлення в телеграм
          sendTelegramMessage(
            errorText,
            statusRequest,
            api,
            fileRequest,
            params,
            response
          )
            .then((response) =>
              console.log("Telegram API response:", response.data)
            )
            .catch((error) => console.error("Telegram API error:", error));
        } else if (
          result.status == "error" &&
          result.error[0] == "access denied"
        ) {
          this.$toast.error(this.$t("accessDenied"));

          var errorText = "Помилка при копіюванні даних";
          var statusRequest = result.status;
          var api = "transDataFromOldCompany";
          var fileRequest =
            "src/views/accounts/allAccounts/viewnew/blocks/companies.vue";
          var params = newObj;
          var response = result;

          // Викликаємо функцію для відправки повідомлення в телеграм
          sendTelegramMessage(
            errorText,
            statusRequest,
            api,
            fileRequest,
            params,
            response
          )
            .then((response) =>
              console.log("Telegram API response:", response.data)
            )
            .catch((error) => console.error("Telegram API error:", error));
        } else {
          this.$toast.error(this.$t("err"));

          var errorText = "Помилка при копіюванні даних";
          var statusRequest = result.status;
          var api = "transDataFromOldCompany";
          var fileRequest =
            "src/views/accounts/allAccounts/viewnew/blocks/companies.vue";
          var params = newObj;
          var response = result;

          // Викликаємо функцію для відправки повідомлення в телеграм
          sendTelegramMessage(
            errorText,
            statusRequest,
            api,
            fileRequest,
            params,
            response
          )
            .then((response) =>
              console.log("Telegram API response:", response.data)
            )
            .catch((error) => console.error("Telegram API error:", error));
        }
      });
    },
    ResetPass() {
      // Скинути пароль

      apiClients.new_reset_passwordClient(this.accountId).then((res) => {
        if (res.status == "done") {
          this.$toast.success(this.$t("resetPasswordDone"));
        } else {
          this.$toast.error(this.$t("err"));

          var errorText = "Помилка при скидувані паролю";
          var statusRequest = result.status;
          var api = "new_reset_passwordClient";
          var fileRequest =
            "src/views/accounts/allAccounts/viewnew/blocks/companies.vue";
          var params = this.form.accountId;
          var response = result;

          // Викликаємо функцію для відправки повідомлення в телеграм
          sendTelegramMessage(
            errorText,
            statusRequest,
            api,
            fileRequest,
            params,
            response
          )
            .then((response) =>
              console.log("Telegram API response:", response.data)
            )
            .catch((error) => console.error("Telegram API error:", error));
        }
      });
    },
    showContextMenu(event, item) {
      // Метод, який викликається при правому кліку на елементі, передаючи подію та об'єкт item

      // Викликаємо метод показу контекстного меню після оновлення DOM
      this.$nextTick(() => {
        // Виклик методу показу контекстного меню у компоненті contextMenu,
        // передаючи подію та об'єкт item
        this.$refs.contextMenu.showContextMenu(event, item);
      });
    },
    switchCntMenu(e, item) {
      // Виконуємо обрану дію з контекстного меню

      switch (e) {
        case "open":
          // Відкрити компанію
          this.openComp(item.companyId);
          break;
        case "CopyName":
          // Відкрити компанію
          this.copy(item.companyName);
          break;
        case "copyIdCompany":
          // Відкрити компанію
          this.copy(item.companyId);
          break;
        case "MoreInformation":
          // Відкрити компанію
          this.objInfoComp.data = item;
          this.objInfoComp.show = true;
          break;
        case "openChecks":
          // Відкрити компанію
          this.tabIndex = 3;
          this.openComp(item.companyId, this.tabIndex);
          break;

        default:
          break;
      }
    },
    copy(item) {
      // копіювання
      if (copy(item) == true) {
        this.$toast.success(this.$t("Copied"));
      } else {
        this.$toast.error(`Fucking mistake, contact Borys`);
      }
      return;
    },
    mutateUser(e) {
      // Метод для форматування користувача компанії
      return mutateUserCompanies(e);
    },
    mutateCompServer(e) {
      // Метод для форматування сервера компанії
      return mutateCompServer(e);
    },
    getServerDisplayName(more) {
      // Відображення назви сервера
      const server = more.companyServer;
      const serverName = more.serverName;

      // Якщо є serverName з xn- кодом - це нова адмінка
      if (serverName && serverName.includes('xn-')) {
        return 'Нова ' + serverName;
      }

      // Якщо немає serverName - це стара адмінка
      const oldServers = ['s-1', 's-2', 'online-2', 'online-3', 'online-4'];
      if (oldServers.includes(server)) {
        return this.$t('OldAdmin') + ' (' + server + ')';
      }

      // Мапа серверів з кодами (xn-...) для випадків коли API не повертає serverName
      const serverCodes = {
        's-3': 's19h',
        's-4': '4t8h',
        's-5': '3s9h',
        's-6': '4s9h',
        's-7': 'si8h',
        's-8': 'n08h',
        's-9': 'sz8h',
        's-10': '7s8h',
      };

      // Якщо є сервер в мапі - формуємо коротку назву
      if (serverCodes[server]) {
        return 'Нова ' + server + ' (xn-' + serverCodes[server] + ')';
      }

      // Якщо немає в мапі - беремо з mutateCompServer
      return mutateCompServer(server).name;
    },
    getServerBadgeClass(more) {
      // Клас бейджа в залежності від сервера
      // Якщо є serverName з xn- - це нова адмінка (синій)
      // Якщо немає serverName і oldServers - стара адмінка (помаранчевий)
      const server = more.companyServer;
      const serverName = more.serverName;

      // Якщо є serverName з xn- кодом - це нова адмінка (синій)
      if (serverName && serverName.includes('xn-')) {
        return 'bg-soft-info text-info server-badge server-badge-new';
      }

      // Стара адмінка - помаранчевий
      const oldServers = ['s-1', 's-2', 'online-2', 'online-3', 'online-4'];
      if (oldServers.includes(server)) {
        return 'bg-soft-warning text-warning server-badge';
      }

      // MySky - фіолетовий
      if (server === 'mysky') {
        return 'bg-soft-primary text-primary server-badge';
      }

      // За замовчуванням - нова адмінка (синій)
      return 'bg-soft-info text-info server-badge server-badge-new';
    },
    isOldVersion(item) {
      // Перевірка чи це стара версія адмінки - тепер не актуально, всі на новій
      return false;
    },
    showCostMethod(item) {
      // Чи показувати метод обліку собівартості
      const server = item.more.companyServer;
      const desc = item.companyDescription;
      const excludedServers = ['mysky', 's-1', 's-2', 's-0', 'online-2', 'online-3', 'online-4'];
      const excludedDescs = ['root', '123', 'debug', 'debug_server'];
      return server && !excludedServers.includes(server) && !excludedDescs.includes(desc);
    },
    showQueueBadge(item) {
      // Чи показувати бейдж черги (тільки для нових адмінок)
      const server = item.more?.companyServer;
      const desc = item.companyDescription;
      const excludedServers = ['mysky', 's-1', 's-2', 's-0', 'online-2', 'online-3', 'online-4'];
      const excludedDescs = ['root', '123', 'debug', 'debug_server'];
      return server && !excludedServers.includes(server) && !excludedDescs.includes(desc);
    },
    getCostMethod(item) {
      // Отримання методу обліку собівартості
      const server = item.more.companyServer;
      if (server === 's-2' || server === 's-4') {
        return 'Середня';
      }
      return 'FIFO';
    },
  },
  computed: {
    filteredCompanies: function () {
      // Фільтрація компаній за текстом пошуку
      return this.uniqueCompanies?.filter((item) => {
        return (
          this.search == "" ||
          item.companyName
            .toString()
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) !== -1 ||
          item.companyId
            .toString()
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) !== -1
        );
      });
    },
    filteredItemsDel: function () {
      // Фільтрація видалених компаній за текстом пошуку
      return this.deletedcompanies?.filter((item) => {
        return (
          this.search == "" ||
          item.companyName
            .toString()
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) !== -1 ||
          item.companyId
            .toString()
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) !== -1
        );
      });
    },
    perms() {
      // Повертаємо права доступу юзера з глобального стору
      return storeS.perms;
    },
  },
};
</script>

<style scoped>
/* Мінімалістичний дизайн карток компаній */
.company-card {
  background-color: var(--vz-card-bg, #fff);
  border: 1px solid #dee2e6;
  border-left: 4px solid var(--vz-success);
  border-radius: 6px;
  padding: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.company-card:hover {
  background-color: var(--vz-secondary-bg, rgba(0, 0, 0, 0.02));
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #c8ccd0;
}

[data-layout-mode="dark"] .company-card {
  border-color: #3a3f44;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

[data-layout-mode="dark"] .company-card:hover {
  border-color: #4a5056;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

/* Заголовок картки */
.company-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.company-card__title {
  font-size: 1.05rem;
  font-weight: 600;
  color: #495057;
  margin: 0;
  word-break: break-word;
  line-height: 1.3;
}

[data-layout-mode="dark"] .company-card__title {
  color: #ced4da;
}

.company-card__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  align-items: center;
}

.company-card__badges .badge {
  font-size: 0.65rem;
  font-weight: 500;
  padding: 0.25rem 0.5rem;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Тіло картки */
.company-card__body {
  flex: 1;
  margin-bottom: 0.75rem;
}

.company-card__id {
  font-size: 0.8rem;
  color: #6c757d;
  margin: 0 0 0.25rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.company-card__id i {
  font-size: 0.75rem;
}

.company-card__desc {
  font-size: 0.8rem;
  color: #212529;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

[data-layout-mode="dark"] .company-card__desc {
  color: #adb5bd;
}

/* Футер картки */
.company-card__footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.7rem;
  color: #6c757d;
  border-top: 1px solid #e9ebec;
  padding-top: 0.5rem;
  margin-top: auto;
}

[data-layout-mode="dark"] .company-card__footer {
  border-top-color: #32383e;
}

.company-card__role,
.company-card__date {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.company-card__role i,
.company-card__date i {
  font-size: 0.8rem;
}

/* Модифікатори */
.company-card--deleted {
  border-left-color: var(--vz-danger);
  opacity: 0.85;
}

.company-card--deleted:hover {
  opacity: 1;
}

.company-card--searched {
  border-left-color: var(--vz-primary);
  background-color: rgba(var(--vz-primary-rgb), 0.05);
}

.company-card--blocked {
  border-left-color: var(--vz-warning);
}

.company-card--old {
  border-left-color: #f7b84b;
  background-color: rgba(247, 184, 75, 0.08);
}

.company-card--old:hover {
  background-color: rgba(247, 184, 75, 0.15);
}

/* Індикатор пошуку - яскравий та помітний */
.company-card__search-indicator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.75rem;
  padding: 0.6rem 1rem;
  background: linear-gradient(135deg, #3b7ddd 0%, #5a95e8 100%);
  color: #ffffff;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  border: none;
  box-shadow: 0 3px 10px rgba(59, 125, 221, 0.4);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.company-card__search-indicator i {
  font-size: 1rem;
  opacity: 1;
}

[data-layout-mode="dark"] .company-card__search-indicator {
  background: linear-gradient(135deg, #4a8df0 0%, #6ba3f5 100%);
  color: #ffffff;
  box-shadow: 0 3px 12px rgba(74, 141, 240, 0.5);
}

/* Soft badge стилі */
.bg-soft-success {
  background-color: rgba(var(--vz-success-rgb), 0.15) !important;
}
.bg-soft-info {
  background-color: rgba(var(--vz-info-rgb), 0.15) !important;
}
.bg-soft-warning {
  background-color: rgba(var(--vz-warning-rgb), 0.15) !important;
}
.bg-soft-primary {
  background-color: rgba(var(--vz-primary-rgb), 0.15) !important;
}
.bg-soft-secondary {
  background-color: rgba(var(--vz-secondary-rgb), 0.15) !important;
}

/* Стилі для бейджів серверів */
.server-badge {
  font-size: 11px !important;
  font-weight: 500 !important;
  padding: 3px 6px !important;
  white-space: nowrap;
}

.server-badge-new {
  border: none !important;
}

/* Адаптивність для малих екранів */
@media (max-width: 1400px) {
  .company-card__badges .badge {
    font-size: 0.6rem;
    padding: 0.2rem 0.4rem;
  }
  .server-badge {
    font-size: 10px !important;
    padding: 2px 5px !important;
  }
}
</style>
